import React, { useState } from 'react';
import {
  Typography,
  TextField,
  FormControl,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Container,
  InputLabel,
  Box,
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import Navigation from '../../components/Navigation';

const SelectDate = () => {
  const [tabValue, setTabValue] = useState(0);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [value, setValue] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        paddingTop: 4,
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h5" align="center" sx={{ marginBottom: 2 }}>
        Select Date & Time
      </Typography>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        centered
        sx={{ marginBottom: 2 }}
      >
        <Tab label="Start Time" />
        <Tab label="End Time" />
      </Tabs>

      <Box spacing={2}>
        <FormControl fullWidth>
          <TextField
            label="Year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            type="number"
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="month-label">Month</InputLabel>
          <Select
            label="Month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                {new Date(0, i).toLocaleString('default', { month: 'long' })}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ mt: 2 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            openTo="day"
            value={value}
            onChange={(newValue) => setValue(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Box>

      <Navigation />
    </Container>
  );
};

export default SelectDate;
